import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    MyTimesheetEntryWorkTypeId,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';
import EntityPathNamesValue from 'components/EntityPathNamesValue';
import { makeSelectMyTimesheetEntryEntityId } from 'services/myTimesheetEntries/selectors';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    entityId?: MyTimesheetEntryWorkTypeId;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryEntityNameValue extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { entityId } = this.props;

        if (!entityId) {
            return null;
        }

        return <EntityPathNamesValue entityId={entityId} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityId: makeSelectMyTimesheetEntryEntityId()
});

export default connect(mapStateToProps)(MyTimesheetEntryEntityNameValue);
